import { Link } from "react-router-dom";
import { HOURS, SALON } from "@/data/salon";

const Footer = () => (
    <footer data-testid="footer" className="bg-ink text-cream border-t border-cream/10">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-20">
            <div className="grid md:grid-cols-3 gap-12">
                <div>
                    <p className="font-serif italic text-3xl">Moovie</p>
                    <p className="text-[0.6rem] tracking-[0.35em] uppercase text-cream/50 mt-1">
                        Parrucchieri
                    </p>
                    <p className="mt-6 text-sm text-cream/60 leading-relaxed max-w-xs">
                        {SALON.legalName}
                        <br />
                        {SALON.address}
                    </p>
                </div>
                <div>
                    <p className="text-xs tracking-[0.25em] uppercase text-cream/50 mb-5">
                        Orari
                    </p>
                    <ul className="text-sm text-cream/70 space-y-2">
                        {HOURS.map((h) => (
                            <li key={h.day} className="flex justify-between gap-6 max-w-[280px]">
                                <span>{h.day}</span>
                                <span className={h.closed ? "italic text-[#E4B7BE]" : ""}>
                                    {h.time}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="text-xs tracking-[0.25em] uppercase text-cream/50 mb-5">
                        Contatti
                    </p>
                    <a
                        href={SALON.phoneHref}
                        data-testid="footer-phone-link"
                        className="block font-serif text-2xl hover:text-[#E4B7BE] transition-colors duration-300"
                    >
                        {SALON.phoneDisplay}
                    </a>
                    <div className="mt-6 flex flex-col gap-2 text-sm">
                        <Link
                            to="/privacy"
                            data-testid="privacy-link"
                            className="text-cream/60 hover:text-cream transition-colors duration-300"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            to="/privacy#cookie"
                            data-testid="cookie-link"
                            className="text-cream/60 hover:text-cream transition-colors duration-300"
                        >
                            Cookie Policy
                        </Link>
                    </div>
                </div>
            </div>
            <div className="mt-14 pt-8 border-t border-cream/10 flex flex-wrap justify-between gap-4 text-xs text-cream/40">
                <p>© {new Date().getFullYear()} {SALON.legalName} — Tutti i diritti riservati.</p>
                <p>Parrucchiere a Paese (Treviso) · Riceviamo su appuntamento</p>
            </div>
        </div>
    </footer>
);

export default Footer;
